import { IBudgetConstruction } from '@apply/api/src/api/ApplyApi';
import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetConstructionField } from '../../../../../queries/useBudgetConstructionField';

interface ExcavationsBackfillProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const ExcavationsBackfill: React.FC<ExcavationsBackfillProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [excavationsBackfill, set_excavationsBackfill] = useBudgetConstructionField<number>(
        propertyGuid,
        (b) => b.values?.['Foundations']?.['Excavations and Backfill'] ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Foundations': { ...b.values?.['Foundations'], 'Excavations and Backfill': v } } })
    );
    const label = 'Excavations and Backfill';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(excavationsBackfill)}
                />
            ) : (
                <MoneyBox
                    id={'excavationsBackfill'}
                    allowNegative={false}
                    value={excavationsBackfill}
                    onChange={(value) => set_excavationsBackfill(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
